import { Task, TaskRowFragmentDoc } from '@graphql/generated';
import { useApolloClient } from '@hooks/useApolloClient';

export const useGetTasksFromCache = (taskIds: Task['id'][]) => {
  const { client } = useApolloClient();

  const tasksRaw: (Task | undefined)[] = taskIds.map((taskId) => {
    // TA-10958: read TaskRow, not TaskDetail. Tasks loaded by listTasks have
    // no team billing block, so a strict TaskDetail read returns null for them
    // and the assignee modal sees no tasks (same failure as TA-10633).
    const task = client?.cache.readFragment({
      id: `Task:${taskId}`,
      fragment: TaskRowFragmentDoc,
      fragmentName: 'TaskRow',
    });

    if (task && (task as Task).__typename === 'Task') {
      return task as Task;
    }
    return;
  });

  const tasks: Task[] = tasksRaw.filter((t) => t !== undefined) as Task[];

  return { tasks };
};
